///all in one
//import axios from "@/axios";
export const trainingGroup = {
  search: {title: '', type: '',apply_for: ''},
  page: 1,
  total: 0,
  dataTraining: []
};

export const trainingGroupGetters = {

  getTrainingGroup: state => {
    return state.trainingGroup;
  },
  getDataTraining: state => {
    return state.trainingGroup.dataTraining;
  },
  getTrainingGroupPage: state => {
    return state.trainingGroup.page;
  },
  getTrainingGroupSearch: state => {
    return state.trainingGroup.search;
  },
  getTrainingGroupTotal: state => {
    return state.trainingGroup.dataTraining.length;
  },
};

export const trainingGroupMutations = {
  changeTrainingGroup(state, value) {
    state.trainingGroup = value;
  },
  changeDataTraining(state, value) {
    state.trainingGroup.dataTraining = value;
  },
  changeTrainingGroupPage(state, value) {
    state.trainingGroup.page = value;
  },
  changeTrainingGroupSearch(state, value) {
    state.trainingGroup.search = value;
  },
  changeResetDataTraining(state){
    state.trainingGroup.dataTraining = [];
  }
};

export const trainingGroupActions = {
  act_loadTrainingGroup: ({ commit }, payload) => {
    commit("changeTrainingGroup", payload);
  }
};
